import React from 'react'

const Error = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <h1>Looks like the page you were looking for does not exist</h1>
    </div>
  )
}

export default Error
